module.exports = __webpack_public_path__ + "static/img/ad4.da268a6.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/mobile/ad4.gif
// module id = TU67
// module chunks = 0